import Block from './Block'

export default class Ressources extends Block {
  constructor(el, destroyLast) {
    super(el, destroyLast)

  }

  getElems() {
    this.ressources = []

    this.allRessources = this.el.querySelectorAll('.ressource')
    this.filters = this.el.querySelectorAll('.filter')

    for (let i = 0; i < this.allRessources.length; i++) {
      const ressource = {
        el: this.allRessources[i],
        filter: this.allRessources[i].dataset.filter
      }

      this.ressources.push(ressource)
    }
  }

  events() {
    for (let i = 0; i < this.filters.length; i++) {
      this.filters[i].addEventListener('click', this.applyFilter.bind(this, i))
    }
  }

  applyFilter(index) {
    for (let i = 0; i < this.filters.length; i++) this.filters[i].classList.contains('active') && this.filters[i].classList.remove('active')
    this.filters[index].classList.add('active')

    const filter = this.filters[index].dataset.slug

    for (let i = 0; i < this.ressources.length; i++) {
      this.ressources[i].el.classList.contains('active') && this.ressources[i].el.classList.remove('active')
      this.ressources[i].el.classList.add('inactive')

      if (this.ressources[i].filter === filter) {
        this.ressources[i].el.classList.remove('inactive')
        this.ressources[i].el.classList.add('active')
      } else if (filter === 'all') {
        this.ressources[i].el.classList.remove('inactive')
        this.ressources[i].el.classList.add('active')
      } else this.ressources[i].el.classList.add('inactive')
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/Ressources.js